import {
  INVOICE_SET_FILTERS,
  INVOICE_RESET_FILTERS,
  INVOICE_SET_PAGINATION,
  INVOICE_RESET_PAGINATION,
  INVOICE_MASTER_DATA,
  INVOICE_SET_SEARCH_RESULTS,
  INVOICE_SET_SEARCHING,
  INVOICE_SET_LOADING,
  INVOICE_SET_INVOICE_DATA,
  INVOICE_SET_COUNTS,
  INVOICE_RESET_FILTER_PAGINATION,
  INVOICE_SET_UPDATE_VARIABLE,
  INVOICE_SET_BALANCE,
  INVOICE_RESET_AND_SET_PAGINATION,
  INVOICE_SAVE_LAST_REQUEST,
  INVOICE_SET_BID_CHARGES_LOADING,
  INVOICE_SET_BID_CHARGES,
} from 'src/actions/constants';
import moment from 'moment';

import { equal } from 'src/Library/Helper';
import { GetChargesListData } from 'src/components/pages/invoicing/types';

const defaultState = {
  statCounts: {},
  searchData: [],
  isSearching: false,
  invoiceData: [],
  isBidChargesLoading: false,
  bidCharges: [] as GetChargesListData,
  shouldUpdate: true,
  isLoading: false,
  shipmentData: {},
  selectedFilters: {
    statusFilter: 'ALL',
    timeFilter: undefined,
    sortBy: 'updated_at',
    startDate: undefined,
    endDate: undefined,
    sortFilter: 'ASC',
    shipmentIdList: undefined,
    idList: undefined,
    organisationIdList: undefined,
  },
  lastRequestPagination: {},
  pagination: {
    pageNo: 1,
    // currentPageNumber: 1,
    // nextOrPrev: 'first',
    // resultPerPage: 10,
    pageSize: 10,
    // isNextPresent: false,
    isLastPage: false,
    // lastSortedColumnValueNext : 0,
    // lastSortedColumnValuePrev: 0,
    // lastRowIdNext: 0,
    // lastRowIdPrev: 0,
  },
};

export default (state: any = defaultState, action) => {
  switch (action.type) {
    case INVOICE_SET_FILTERS: {
      return {
        ...state,
        selectedFilters: {
          ...state.selectedFilters,
          ...action.filters,
        },
        pagination: defaultState.pagination,
        shouldUpdate: action.shouldUpdate || false,
      };
    }
    case INVOICE_RESET_FILTERS: {
      return {
        ...state,
        selectedFilters: defaultState.selectedFilters,
        pagination: defaultState.pagination,
        shouldUpdate: true,
      };
    }
    case INVOICE_SET_PAGINATION: {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          pageNo: action.data?.pageNo || state.pagination.pageNo,
          // currentPageNumber: action.data && action.data.currentPageNumber
          //   || state.pagination.currentPageNumber,
          // resultPerPage: action.data && action.data.resultPerPage || state.pagination.resultPerPage,
          pageSize: action.data?.pageSize || state.pagination.pageSize,
          // nextOrPrev: action.data && action.data.nextOrPrev || state.pagination.nextOrPrev,
          // isNextPresent: action.data && action.data.isNextPresent || false,
          isLastPage: action.data?.isLastPage || false,
          // lastSortedColumnValueNext: action.data && action.data.lastSortedColumnValueNext
          //   || state.pagination.lastSortedColumnValueNext,
          // lastSortedColumnValuePrev: action.data && action.data.lastSortedColumnValuePrev
          //   || state.pagination.lastSortedColumnValuePrev,
          // lastItemIdNext: action.data && action.data.lastItemIdNext
          //   || state.pagination.lastItemIdNext,
          // lastItemIdPrev: action.data && action.data.lastItemIdPrev ||
          //   state.pagination.lastItemIdPrev,
        },
        shouldUpdate: action.shouldUpdate || false,
      };
    }
    case INVOICE_RESET_PAGINATION: {
      return {
        ...state,
        pagination: defaultState.pagination,
        shouldUpdate: true,
      };
    }
    case INVOICE_MASTER_DATA: {
      return {
        ...state,
        masterData: action.data,
      };
    }
    case INVOICE_SET_SEARCH_RESULTS: {
      return {
        ...state,
        searchData: action.data,
      };
    }
    case INVOICE_SET_SEARCHING: {
      return {
        ...state,
        isSearching: action.data,
      };
    }
    case INVOICE_SET_LOADING: {
      return {
        ...state,
        isLoading: action.data,
      };
    }
    case INVOICE_SET_INVOICE_DATA: {
      return {
        ...state,
        invoiceData: action.data,
        shouldUpdate: true,
      };
    }
    case INVOICE_SET_COUNTS: {
      return {
        ...state,
        statCounts: action.data
      };
    }
    case INVOICE_RESET_FILTER_PAGINATION: {
      return {
        ...state,
        pagination: defaultState.pagination,
        selectedFilters: defaultState.selectedFilters,
        shouldUpdate: equal(state.pagination, defaultState.pagination) &&
          equal(state.selectedFilters, defaultState.selectedFilters) || false,
      };
    }
    case INVOICE_SET_UPDATE_VARIABLE: {
      return {
        ...state,
        shouldUpdate: true,
      };
    }
    case INVOICE_SET_BALANCE: {
      return {
        ...state,
        balance: action.data,
      };
    }
    case INVOICE_RESET_AND_SET_PAGINATION: {
      return {
        ...state,
        pagination: {
          ...defaultState.pagination,
          // resultPerPage: action.resultPerPage,
          pageSize: action.pageSize,
        },
        shouldUpdate: true,
      };
    }
    case INVOICE_SAVE_LAST_REQUEST : {
      return {
        ...state,
        lastRequestPagination: action.data,
      };
    }
    case INVOICE_SET_BID_CHARGES_LOADING: {
      return {
        ...state,
        isBidCharges: action.data,
      };
    }
    case INVOICE_SET_BID_CHARGES: {
      return {
        ...state,
        bidCharges: action.data,
      };
    }
    default: return state;
  }
};
